import {isSameDay, parse} from 'date-fns';

import {DateFormatEnum} from 'presentation/constants';
import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';
import {translations} from 'presentation/translations-new';

import {ShortcutAppointment} from '../types';

const {emergencyTelehealth} = translations['pt-br'].privateFlow.services;

const hasTelehealthAppointmentToday = (appointments: ShortcutAppointment[], now: Date) =>
	appointments
		.filter(item => item.bookingType === BookingTypeEnum.TELEHEALTH)
		.some(item =>
			isSameDay(parse(item.date, DateFormatEnum.DATE_FORMAT_1, new Date()), now),
		);

const shouldOpenWarningDrawer = (
	title: string,
	appointments: ShortcutAppointment[] | undefined,
	now: Date = new Date(),
) => {
	if (title !== emergencyTelehealth || !appointments) return false;

	return hasTelehealthAppointmentToday(appointments, now);
};

export {shouldOpenWarningDrawer};
